import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { AppBarWithButtons } from '../../../../components/designe/app-bars/app-bar-with-action-buttons/AppBarWithButtons';
import AppProgramCollectionAvatar from '../../../../components/designe/app-entity-avatar/app-program-collection-avatar/AppProgramCollectionAvatar';
import AppSelectWrapper from '../../../../components/designe/textfields/app-select-wrapper/AppSelectWrapper';
import AppTextField from '../../../../components/designe/textfields/app-text-field/AppTextField';
import { useGetUserProgramCollections } from '../../../../redux/api/programsAPI';
import { AvatarSize, AvatarTypes } from '../../../../shared/constants';
import { IProgramCollection } from '../../../../types/interfaces/program-collection';
import { IProgramItem } from '../../../../types/interfaces/program-item';
import { useStyles } from './CopyProgramItem.style';

interface ICopyProgramItemProps {
  programItem: IProgramItem;
  onCancel: () => void;
  onCopyProgramItem: (title: string, id?: string) => Promise<any>;
}

export default function CopyProgramItem(props: ICopyProgramItemProps) {
  const { onCancel, onCopyProgramItem } = props;
  const [loader, setLoader] = useState<boolean>(false);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [title, setTitle] = useState('');
  const { data: programs } = useGetUserProgramCollections();
  const { t } = useTranslation();
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const placeholder = `${props.programItem.title}(${t('common.copy')})`;

  return (
    <Box className={classes.copyProgramItemWrapper}>
      <Box display="flex" flexDirection="column" gap={1}>
        <AppTextField
          label={t('common.title')}
          fullWidth
          value={title}
          placeholder={placeholder}
          onChange={(e) => setTitle(e.target.value)}
        />
        <AppSelectWrapper
          label={t('programs.programCollection')}
          fieldName={'title'}
          options={programs}
          defaultValue={selectedProgram}
          onChange={(e) => {
            setSelectedProgram(e?.target?.value || null);
          }}
          className={classes.selectorWithContent}
          renderOption={(programCollection: IProgramCollection) => (
            <Box className={classes.programWrapper}>
              <AppProgramCollectionAvatar
                programCollection={programCollection}
                size={AvatarSize.s}
                type={AvatarTypes.round}
              />
              <div>{programCollection.title}</div>
            </Box>
          )}></AppSelectWrapper>
      </Box>

      <Box className={classes.copyProgramItemBottom}>
        <AppBarWithButtons
          loading={loader}
          onClick={() => {
            setLoader(true);
            onCopyProgramItem(
              title || placeholder,
              selectedProgram?.id,
            ).finally(() => {
              setLoader(false);
            });
          }}
          onCancelClick={onCancel}
        />
      </Box>
    </Box>
  );
}
